import { useQueryClient } from 'react-query';
import { useModelContext } from 'modules/Models/components/ModelContext/ModelContext';
import { useIsLoggedIn } from 'modules/Auth/hooks';
import { useModelTypeInfo } from 'modules/Models/hooks/useModelTypeInfo';
import { useMstModel } from 'utils/mst/useMstModel';
import { ModelPredictionsStoreMST } from 'modules/Predictions/mst/ModelPredictionStore';
import { extractInputsFromMetadata } from 'utils/predictions/extractInputsFromMetadata';
import { MstPredictionStoreCtx } from 'modules/Predictions/contexts/MstPredictionStoreCtx';

export const MstPredictionStoreCtxProvider: React.FC = ({ children }) => {
  const qc = useQueryClient();
  const { model } = useModelContext();
  const isLoggedIn = useIsLoggedIn();
  const { modelTypeForUi: renderingCategory } = useModelTypeInfo(model);
  const store = useMstModel(ModelPredictionsStoreMST, [model, qc, renderingCategory, isLoggedIn], () => [
    {
      viewState: {
        isLoggedIn,
      },
      entity: { type: 'model' as const, data: model },
      media: {
        presetContent: extractInputsFromMetadata(model.metadata),
      },
      renderingCategory,
    },
    { queryClient: qc },
  ]);

  return <MstPredictionStoreCtx.Provider value={store}>{children}</MstPredictionStoreCtx.Provider>;
};
